module.exports = __webpack_public_path__ + "static/media/ic_check.7fdf6cd3.svg";